"use client";
import React from "react";
import useTextColorBasedOnBackground from "../../hooks/useTextColorBasedOnBackground";
import { SubheaderSpanProps } from "./types";

export default function SubheaderSpan({
  children,
  backgroundColor,
}: SubheaderSpanProps) {
  const textColorClass = useTextColorBasedOnBackground(backgroundColor);

  return (
    <span
      className={`inline-block px-[16px] py-[12px] rounded font-bold my-[6px] ${textColorClass}`}
      style={{ backgroundColor: backgroundColor ?? "#ccc" }}
    >
      {children}
    </span>
  );
}
